import {
  ActionTypes,
  SET_LOADER,
  SET_TEMPORARY_DRAWER,
  SystemState,
} from './types';

const initialState: SystemState = {
  loading: false,
  showTemporaryDrawer: false,
  activeTheme: 'theme1',
};

export function systemReducer(
  state = initialState,
  action: ActionTypes,
): SystemState {
  switch (action.type) {
    case SET_LOADER:
      return { ...state, loading: action.payload };

    case SET_TEMPORARY_DRAWER:
      return { ...state, showTemporaryDrawer: action.payload };

    default:
      return state;
  }
}
